import { Modal } from "antd";

function ModalCustom(props) {
  const { closable, children, open, onCancel, ...other } = props;
  return (
    <Modal
      closable={closable}
      centered
      className="rounded-4"
      {...other}
      style={{ fontFamily: "Sarabun", fontSize: "14px" }}
      open={open}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      onCancel={onCancel}
    >
      {children}
    </Modal>
  );
}

export default ModalCustom;
